import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
import { Progress } from 'app/components/match/ProgressBar';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1sucvv7-0"
})(["display:flex;height:", ";width:", ";background-color:", ";position:absolute;bottom:0;"], SIZES['2'], SIZES['44'], COLORS.lightGrey);
export default function MatchRowTeaserProgressBar(_ref) {
  let {
    progress
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MatchRowTeaserProgressBar",
    "data-sentry-source-file": "MatchRowTeaserProgressBar.tsx"
  }, /*#__PURE__*/React.createElement(Progress, {
    "data-testid": "progress-bar",
    progress: progress,
    "data-sentry-element": "Progress",
    "data-sentry-source-file": "MatchRowTeaserProgressBar.tsx"
  }));
}